import { defineMessages } from "react-intl";

const baseId = "t.components.navigationStepper.";

export default defineMessages({
  welcome: {
    id: `${baseId}welcome`,
    defaultMessage: "WELCOME",
  },
  admin: {
    id: `${baseId}admin`,
    defaultMessage: "CONSOLE ADMIN",
  },
  adminCertificationConfigurationsManagement: {
    id: `${baseId}adminCertificationConfigurationsManagement`,
    defaultMessage: "CERTIFICATION CONFIGURATIONS MANAGEMENT",
  },
  adminUsersManagement: {
    id: `${baseId}adminUsersManagement`,
    defaultMessage: "USERS MANAGEMENT",
  },
  adminApplicationsAbilitationsManagement: {
    id: `${baseId}adminApplicationsAbilitationsManagement`,
    defaultMessage: "APPLICATIONS ABILITATIONS MANAGEMENT",
  },
  adminBRManagement: {
    id: `${baseId}adminBRManagement`,
    defaultMessage: "BUSINESS ROLE MANAGEMENT",
  },
  adminCatalogManagement: {
    id: `${baseId}adminCatalogManagement`,
    defaultMessage: "CATALOG MANAGEMENT",
  },
  adminPasswordManagement: {
    id: `${baseId}adminPasswordManagement`,
    defaultMessage: "PASSWORD MANAGEMENT",
  },
  adminExternalPortalManagement: {
    id: `${baseId}adminExternalPortalManagement`,
    defaultMessage: "EXTERNAL PORTAL MANAGEMENT",
  },
  adminSODManagement: {
    id: `${baseId}adminSODManagement`,
    defaultMessage: "SOD MANAGEMENT",
  },
  adminServiceRequestManagement: {
    id: `${baseId}adminServiceRequestManagement`,
    defaultMessage: "SERVICE REQUEST MANAGEMENT",
  },
  adminManualsManagement: {
    id: `${baseId}adminManualsManagement`,
    defaultMessage: "MANUALS MANAGEMENT",
  },
  adminReportManagement: {
    id: `${baseId}adminReportManagement`,
    defaultMessage: "REPORT MANAGEMENT",
  },
  adminTemplateMailManagement: {
    id: `${baseId}adminTemplateMailManagement`,
    defaultMessage: "TEMPLATE MAIL MANAGEMENT",
  },
  adminTemplateSmsManagement: {
    id: `${baseId}adminTemplateSmsManagement`,
    defaultMessage: "TEMPLATE SMS MANAGEMENT",
  },
  adminWorkflowManagement: {
    id: `${baseId}adminWorkflowManagement`,
    defaultMessage: "WORKFLOW MANAGEMENT",
  },
  adminTablesConfigurationManagement: {
    id: `${baseId}adminTablesConfigurationManagement`,
    defaultMessage: "TABLES CONFIGURATION MANAGEMENT",
  },
  adminRecoveryPointManagement: {
    id: `${baseId}adminRecoveryPointManagement`,
    defaultMessage: "RECOVERY POINT MANAGEMENT",
  },
  adminProfilesManagement: {
    id: `${baseId}adminProfilesManagement`,
    defaultMessage: "PROFILES MANAGEMENT",
  },
  temporaryAbilitations: {
    id: `${baseId}temporaryAbilitations`,
    defaultMessage: "TEMPORARY ABILITATIONS",
  },
  technicalUser: {
    id: `${baseId}technicalUser`,
    defaultMessage: "TECHNICAL USER",
  },
  createCertification: {
    id: `${baseId}createCertification`,
    defaultMessage: "CREATE CERTIFICATION",
  },
  adminAuditsManagement: {
    id: `${baseId}adminAuditsManagement`,
    defaultMessage: "AUDITS MANAGEMENT",
  },
  entitlementRequest: {
    id: `${baseId}entitlementRequest`,
    defaultMessage: "ENTITLEMENT REQUEST",
  },
  profileManagement: {
    id: `${baseId}profileManagement`,
    defaultMessage: "PROFILE MANAGEMENT",
  },
  requestHistory: {
    id: `${baseId}requestHistory`,
    defaultMessage: "HISTORY REQUEST",
  },
  approvals: {
    id: `${baseId}approvals`,
    defaultMessage: "APPROVALS",
  },
  tasks: {
    id: `${baseId}tasks`,
    defaultMessage: "TASKS",
  },
  manuals: {
    id: `${baseId}manuals`,
    defaultMessage: "MANUALS",
  },
  externalPortalSection: {
    id: `${baseId}externalPortal`,
    defaultMessage: "EXTERNAL PORTAL",
  },
  catalog: {
    id: `${baseId}catalog`,
    defaultMessage: "CATALOG",
  },
  delegates: {
    id: `${baseId}delegates`,
    defaultMessage: "DELEGATES",
  },
  entitlementsReferences: {
    id: `${baseId}entitlementsReferences`,
    defaultMessage: "ENTITLEMENTS REFERENCES",
  },
  usersReferences: {
    id: `${baseId}usersReferences`,
    defaultMessage: "USERS REFERENCES",
  },
  userEntitlement: {
    id: `${baseId}userEntitlement`,
    defaultMessage: "USER ENTITLEMENTS",
  },
  emergencyUsers: {
    id: `${baseId}emergencyUsers`,
    defaultMessage: "EMERGENCY USERS",
  },
  businessRolesManagement: {
    id: `${baseId}businessRolesManagement`,
    defaultMessage: "BUSINESS ROLE MANAGEMENT",
  },
  resetPassword: {
    id: `${baseId}resetPassword`,
    defaultMessage: "RESET PASSWORD",
  },
  changePassword: {
    id: `${baseId}changePassword`,
    defaultMessage: "CHANGE PASSWORD",
  },
  serviceRequest: {
    id: `${baseId}serviceRequest`,
    defaultMessage: "SERVICE REQUEST",
  },
  certificationReference: {
    id: `${baseId}certificationReference`,
    defaultMessage: "EXAMINE RECERTIFICATION CAMPAIGN",
  },
  report: {
    id: `${baseId}reports`,
    defaultMessage: "REPORTS",
  },
  notFound: {
    id: `${baseId}notFound`,
    defaultMessage: "NOT FOUND",
  },
  consoleAdminTablesConfiguration: {
    id: `${baseId}consoleAdminTablesConfiguration`,
    defaultMessage: "TABLES_CONFIGURATION",
  },
  adminTemporaryAbilitationsManagement: {
    id: `${baseId}adminTemporaryAbilitationsManagement`,
    defaultMessage: "TEMPORARY ABILITATIONS MANAGEMENT",
  },
  adminUigpMgmt: {
    id: `${baseId}adminUigpMgmt`,
    defaultMessage: "UIGP MANAGEMENT",
  },
  adminCsvUploader: {
    id: `${baseId}adminCsvUploader`,
    defaultMessage: "FILE MANAGEMENT",
  },
  adminTechnicalUsers: {
    id: `${baseId}adminTechnicalUsers`,
    defaultMessage: "TECHNICAL USERS MANAGEMENT",
  },
});
